<script>
    import EmptyState from '@itslearning/prometheus/assets/nodes/EmptyState/v1/EmptyState.svelte';
    import Page from './Page/Page.svelte';
    import {txt} from '../i18n/i18n';
    import {navigateToViewSurveyPage} from '../navigation';
    import {surveyTitle} from '../stores';
    import {isInIframe} from '../helpers';    
</script>

<Page title={isInIframe() ? txt('Survey') : surveyTitle} displayHeading={!isInIframe()}>
    <EmptyState title={txt('Thanks_for_taking_the_survey')} 
        showLink={isInIframe()}
        iconName="project" 
        href={isInIframe() ? '#View' : null} 
        linkText={isInIframe() ? txt('Survey_start_page') : null} 
        on:click={navigateToViewSurveyPage}
    />
</Page>
